
(function ($) {


    function sidebarTouch() {
        $(".sidebar:not(.sidebar__nav)").each(function () {

            // const openModalBtn = document.getElementById('openModalBtn');
            const modal = $(this);
            if (!$(this).find('.sidebar__header').length > 0) {
                return
            }
            const modalHeader = $(this).find('.sidebar__header');
            const $content = $(this).find('.sidebar__wrapper');
            let startY = 0;
            let currentY = 0;
            let isDragging = false;
            let isSwipingDown = false;
            let isHeaderDragging = false;
            let draggingContent = false;
            let lastDeltaY = 0;

            let lastScrollTop = 0;
            let draggingUp = false;
            let contentCurrent = 0;

            function handleTouchStart(e) {

                if ($content.scrollTop() !== 0) {
                    draggingContent = true;
                }
                contentCurrent = $content.scrollTop();
                if (isHeaderDragging){

                }
                startY = e.touches[0].clientY;
                isDragging = true;
                isSwipingDown = false;
                draggingUp = false;
                lastDeltaY = 0;
            }


            function handleTouchMove(e) {

                if (contentCurrent !== 0 && !isHeaderDragging){
                    return
                }

                if (!isDragging) return;
                currentY = e.touches[0].clientY;
                const deltaY = currentY - startY;
                const atTop = $content[0].scrollTop === 0;

                draggingUp = deltaY < lastScrollTop;
                lastScrollTop = deltaY;

                if (deltaY > 0 && atTop) {
                    e.stopPropagation();
                    e.preventDefault();
                    isSwipingDown = true;
                    modal[0].style.transform = `translateY(${deltaY}px)`;
                } else if (deltaY > 0 && draggingContent) {
                    e.stopPropagation();
                    e.preventDefault();
                    isSwipingDown = true;
                    modal[0].style.transform = `translateY(${deltaY}px)`;
                } else if (deltaY < lastDeltaY) {
                    isSwipingDown = false;
                    modal.css('transform', '');
                }
                lastDeltaY = deltaY;

            }

            function handleTouchEnd(e) {
                e.stopPropagation();
                if (lastDeltaY > 100 && !draggingUp && isSwipingDown) {
                    $(document).trigger("close_modal", "filters")
                } else {
                    modal.css('transform', '');
                }

                draggingContent = false;
                setTimeout(function(){
                    modal.css('transform', '');
                }, 200);
                isDragging = false;
                draggingUp = false;
                isHeaderDragging = false;
                contentCurrent = $content.scrollTop();
            }


            modal[0].addEventListener("touchstart", handleTouchStart);
            modal[0].addEventListener("touchend", handleTouchEnd);
            modal[0].addEventListener("touchmove", handleTouchMove);


            modalHeader[0].addEventListener("touchstart", (e) => {
                e.stopPropagation(); // Zastaví šíření na modal
                isHeaderDragging = true;
                handleTouchStart(e);
            });
            modalHeader[0].addEventListener("touchmove", handleTouchMove);
            modalHeader[0].addEventListener("touchend", handleTouchEnd);


        });
    }

    $(document).gp_ready(function (){
        sidebarTouch();
    })


})(jQuery);


